export const SIMULATION_SETUP_PATH = '/simulation-setup';
export const SIMULATION_SETUP_LEGACY_PATH = '/simulation-setup/legacy';
